import {
    Chart,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartValueAxis,
    ChartValueAxisItem,
    ChartLegend,
    ChartArea,
    ChartXAxis,
    ChartXAxisItem,
    ChartYAxis,
    ChartYAxisItem,
} from "@progress/kendo-react-charts";


export interface ChartPropsData {
    seriesDefaults: {
        type: "scatterLine",
        style: "smooth",
        markers: {
            visible: boolean,
        },
        width: number,
    },
    legend: {
        position: string,
        labels: {
            font: string,
            color: string,
        },
    },
    series: Array<{
        name: string,
        data: any,
        color: string,
    }>,
    count?: number,
}

const ScatterLineChart: React.FC<ChartPropsData> = (data) => {
    return (
        <>
            <Chart style={{ height: "60%", backgroundColor: "transparent", marginBottom: "5px" }}>
                <ChartArea
                    background="transparent"
                    height={data?.count === 2 ? 220 : 240}
                />
                <ChartLegend
                    position="bottom"
                    labels={data?.legend.labels}
                />
                <ChartCategoryAxis>
                    <ChartCategoryAxisItem
                        labels={{
                            color: "white",
                        }}
                    />
                </ChartCategoryAxis>
                <ChartValueAxis>
                    <ChartValueAxisItem
                        labels={{
                            color: "white",
                        }}
                        minorGridLines={{ visible: false }}
                    />
                </ChartValueAxis>
                <ChartSeries>
                    {data?.series.map((item, idx) => (
                        <ChartSeriesItem
                            key={idx}
                            type="scatterLine"
                            style="smooth"
                            data={item.data}
                            name={item.name}
                            color={item.color}
                            markers={{ visible: false }}
                            width={2}
                        />
                    ))}
                </ChartSeries>
                <ChartXAxis>
                    <ChartXAxisItem
                        title={{ font: "12px Mulish", color: "#fff" }}
                        color="#fff"
                        majorGridLines={{ width: 0.8, color: "#A0A0A0" }}
                        minorGridLines={{ visible: false }}
                        axisCrossingValue={[0, 10]}
                    />
                </ChartXAxis>
                <ChartYAxis>
                    <ChartYAxisItem
                        title={{ font: "12px Mulish", color: "#fff" }}
                        color="#fff"
                        majorGridLines={{ width: 0.8, color: "#A0A0A0" }}
                        minorGridLines={{ visible: false }}
                    />
                </ChartYAxis>
            </Chart>
        </>
    )
}

export default ScatterLineChart;